const DEFAULT_MOYEN_DE_PAIEMENT = 'ESPECE'
export default {
  namespaced: true,
  state: {
    postesVersement: [],
    sontToutPostesVersementsSelectionnes: false,
    dates: [],
    moyenDePaiement: DEFAULT_MOYEN_DE_PAIEMENT,
  },
  mutations: {
    ADD_POSTE(state, ajouterPosteAVerser) {
      state.postesVersement.push({
        posteAim: ajouterPosteAVerser.poste,
        montant: ajouterPosteAVerser.montant,
      })
    },
    REMOVE_POSTE(state, _poste) {
      let i = state.postesVersement.findIndex((v) => v.posteAim.posteAIMId === _poste.posteAIMId)
      if (i > -1) {
        state.postesVersement.splice(i, 1)
      }
    },
    REMOVE_ALL_POSTE(state) {
      state.postesVersement = []
    },
    SET_SONT_TOUT_POSTES_VERSES(state, sontToutPostesVersementsSelectionnes) {
      state.sontToutPostesVersementsSelectionnes = sontToutPostesVersementsSelectionnes
    },
    SET_DATES(state, dates) {
      state.dates = dates
    },
    SET_MOYEN(state, moyen) {
      state.moyenDePaiement = moyen
    },
    SET_MONTANT_POSTE(state, { _poste, _montant }) {
      let i = state.postesVersement.findIndex((v) => v.posteAim.posteAIMId === _poste.posteAIMId)
      if (i > -1) {
        state.postesVersement[i].montant = _montant
      }
    },
    RAZ_DATES(state) {
      state.dates = []
    },
    RAZ_MOYEN(state) {
      state.moyenDePaiement = DEFAULT_MOYEN_DE_PAIEMENT
    },
    RAZ_POSTES(state) {
      state.postesVersement = []
    },
  },
  getters: {
    getPostesVersements: (state) => {
      return state.postesVersement
    },
    estPosteVersementSelectionne: (state) => (_poste) => {
      return state.postesVersement.some((p) => p.posteAim.posteAIMId === _poste.posteAIMId)
    },
    sontToutPostesVersementSelectionne: (state) => state.sontToutPostesVersementsSelectionnes,
    getNombreVersements: (state) => state.dates.length,
    getDatesVersements: (state) => state.dates,
    getMoyenDePaiementId: (state) => state.moyenDePaiement,
    getLignesVersements: (state) => {
      let lignes = {}
      state.postesVersement.forEach((poste) => {
        lignes[poste.posteAim.posteAIMId] = poste.montant
      })
      return lignes
    },
    isValid: (state) =>
      state.moyenDePaiement !== undefined && state.dates.length > 0 && state.postesVersement.length > 0,
  },

  actions: {
    async ajouterPosteAVerser({ commit }, ligneFicheAim) {
      commit('ADD_POSTE', {
        poste: ligneFicheAim.poste,
        montant: calculerMontantAVerser(ligneFicheAim),
      })
    },
    async ajouterToutLesPostes({ commit }, lignesFicheAim) {
      lignesFicheAim.forEach((ligneFicheAim) => {
        commit('ADD_POSTE', {
          poste: ligneFicheAim.poste,
          montant: calculerMontantAVerser(ligneFicheAim),
        })
      })
      commit('SET_SONT_TOUT_POSTES_VERSES', true)
    },
    async retirerPosteAVerser({ commit }, _poste) {
      commit('REMOVE_POSTE', _poste)
    },
    async retirerToutLesPostesAVerser({ commit }) {
      commit('REMOVE_ALL_POSTE')
      commit('SET_SONT_TOUT_POSTES_VERSES', false)
    },

    async setDates({ commit }, _dates) {
      commit('SET_DATES', _dates)
    },
    async setMoyenDePaiement({ commit }, _moyen) {
      commit('SET_MOYEN', _moyen)
    },
    async changerMontantPoste({ commit }, _changerMontantPosteCommand) {
      commit('SET_MONTANT_POSTE', _changerMontantPosteCommand)
    },
    async razAll({ commit }) {
      commit('RAZ_DATES')
      commit('RAZ_POSTES')
      commit('RAZ_MOYEN')
    },
  },
}
function calculerMontantAVerser(ligneFicheAim) {
  let montant = ligneFicheAim.montantInitial
  ligneFicheAim.operations.forEach((operation) => (montant += operation.montant))
  return montant
}
